import { render, staticRenderFns } from "./MaterialsEdit.vue?vue&type=template&id=6b1327fa&"
import script from "./MaterialsEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports